var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{attrs:{"content-class":"","nav-class":"ml-1"}},[_c('b-tab',{attrs:{"no-body":"","title":_vm.$t('routes.EXCMCallLogList')}},[_c('b-card',[_c('CallLogTable')],1)],1),_c('b-tab',{attrs:{"no-body":"","title":_vm.$t('menu.excmcalllogs.statistic')}},[_c('b-card',[_c('CallLogStatisticTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }